import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { assetStorageApi } from 'src/Services/API';
import { trackEvent } from 'src/Services/Matomo';

export const useRenameStorageItem = (
  options?: UseMutationOptions<void, unknown, { name: string; itemId: string }>
) => {
  const assetId = useCurrentAssetId();
  const queryClient = useQueryClient();

  return useMutation<void, unknown, { name: string; itemId: string }>(
    'rename-document',
    async ({ itemId, name }) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      const response = await assetStorageApi.assetStorageControllerRenameItem(assetId, itemId, {
        name,
      });
      return response.data;
    },
    {
      ...options,
      onSettled: (data, error, variables, context) => {
        options?.onSettled?.(data, error, variables, context);
        queryClient.invalidateQueries({ queryKey: ['fetch-documents', assetId] });
      },
      onSuccess: (data, variables, context) => {
        trackEvent('Document', 'rename', 'file');
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
